import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: var(--neutral-bg-strong);
  position: absolute;
  height: ${({ isLandscape }) => (isLandscape ? '2px' : '100%')};
  width: ${({ isLandscape }) => (isLandscape ? '100%' : '2px')};
  top: ${({ isLandscape }) => (isLandscape ? '50%' : '0')};
`;

export const ProgressLineComplete = styled.div`
  background-color: var(--secondary-1-bg);
  height: ${({ isLandscape, progress }) =>
    isLandscape ? '100' : progress * 100}%;
  width: ${({ isLandscape, progress }) =>
    isLandscape ? progress * 100 : '100'}%;
`;
